<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  item: { type: Object, default: null },
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  links: { type: Array, default: () => [] },
  rootUrl: { type: Function, default: value => String(value || '') },
});

const emit = defineEmits(['close']);

const dialogRef = ref(null);

defineExpose({
  open: () => dialogRef.value?.open(),
  close: () => dialogRef.value?.close(),
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="Anúncios no concorrente"
    cancel-button-label="Fechar"
    width="xl"
    position="top"
    overflow-y-auto
    :show-confirm-button="false"
    @close="emit('close')"
  >
    <div class="space-y-4 text-[13px] text-lais-text">
      <div
        v-if="item"
        class="rounded-lais border border-lais-border bg-lais-bg-page px-4 py-3"
      >
        <p class="text-[11px] font-bold uppercase text-lais-text-muted">
          {{ item.kindLabel || 'Pendente' }}
        </p>
        <p class="mt-1 font-semibold text-lais-text">
          {{ title }}
        </p>
        <p v-if="subtitle" class="mt-0.5 text-[12px] text-lais-text-muted">
          {{ subtitle }}
        </p>
      </div>

      <div class="grid gap-2">
        <template v-for="link in links" :key="link.key">
          <span
            v-if="link.inactive"
            v-tooltip.top="link.title"
            :title="link.title"
            class="block"
          >
            <button
              type="button"
              disabled
              class="flex h-12 w-full cursor-not-allowed items-center gap-3 rounded-lais border border-red-200 bg-red-50 px-3 text-left text-red-700 opacity-95"
              :aria-label="link.title"
            >
              <span
                class="inline-flex h-8 shrink-0 items-center gap-1 rounded-full bg-white px-2.5 text-[12px] font-semibold ring-1 ring-red-100"
              >
                Abrir
                <span class="i-lucide-circle-off size-3" aria-hidden="true" />
              </span>
              <span class="min-w-0 flex-1">
                <span class="block truncate text-[12px] font-semibold">
                  {{ link.root || rootUrl(link.url) }}
                </span>
                <span class="block truncate text-[11px] font-semibold">
                  anúncio inativo no concorrente
                </span>
              </span>
            </button>
          </span>
          <a
            v-else
            :href="link.url"
            target="_blank"
            rel="noopener noreferrer"
            class="flex h-12 w-full items-center gap-3 rounded-lais border border-lais-border bg-white px-3 text-left text-lais-text transition hover:border-lais-primary hover:bg-lais-primary-50"
            :title="link.title"
          >
            <span
              class="inline-flex h-8 shrink-0 items-center gap-1 rounded-full bg-lais-primary-50 px-2.5 text-[12px] font-semibold text-lais-primary"
            >
              Abrir
              <span class="i-lucide-external-link size-3" aria-hidden="true" />
            </span>
            <span class="min-w-0 flex-1">
              <span class="block truncate text-[12px] font-semibold">
                {{ link.root || rootUrl(link.url) }}
              </span>
              <span class="block truncate text-[11px] text-lais-text-muted">
                {{ link.url }}
              </span>
            </span>
          </a>
        </template>
      </div>
    </div>
  </Dialog>
</template>
